/** PDM `part_attributes[].attribute` labels (ASCII) per mapping doc. */

export const PDM_PART_ATTRIBUTES = {
  SEATING_ROW: "Seating Row",
  DRIVER_SEAT_TYPE: "Driver Seat Type",
  PASSENGER_SEAT_TYPE: "Passenger Seat Type",
  FRONT_ROW: "Front Row",
  BACK_ROW: "Back Row",
  MIDDLE_ROW: "Middle Row",
  KIT_TYPE: "Kit Type",
  PERFORATION_LOCATION: "Perforation Location",
  PRIMARY_COLOR: "Primary Color",
  SECONDARY_COLOR: "Secondary Color",
  STITCHING_COLOR: "Stitching Color",
  INVENTORY: "Inventory",
} as const
